"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PillsMultipleSelect = void 0;
const react_1 = __importStar(require("react"));
const forms_1 = require("../../forms");
const PillsMultipleSelect_styles_1 = require("./PillsMultipleSelect.styles");
const PillsMultipleSelect = ({ title, translationKey, items, selectedValues, setSelectedValues, translationEditHandler, }) => {
    const onChange = (0, react_1.useMemo)(() => (item) => {
        const alreadySelected = selectedValues.find((selectedValue) => selectedValue === item);
        if (alreadySelected) {
            setSelectedValues(selectedValues.filter((selectedValue) => selectedValue !== item));
        }
        else {
            setSelectedValues([...selectedValues, item]);
        }
    }, [selectedValues, setSelectedValues]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        title && (react_1.default.createElement(PillsMultipleSelect_styles_1.Title, null,
            react_1.default.createElement(forms_1.EditableTitle, { name: title, editHandler: (isCancelled, value) => translationEditHandler && value && translationEditHandler(isCancelled, value, translationKey), isEditable: !!translationKey }))),
        react_1.default.createElement(PillsMultipleSelect_styles_1.PillsWrapper, { "$inlineTranslation": !!translationKey }, items
            .filter((i) => !i.hide)
            .map((item, index) => {
            const Icon = item.icon;
            return (react_1.default.createElement(react_1.default.Fragment, { key: index },
                react_1.default.createElement(PillsMultipleSelect_styles_1.RadioInput, { id: item.value, value: item.value, disabled: item.disabled, type: "checkbox", checked: selectedValues.find((selectedValue) => selectedValue === item.value) !== undefined, onChange: () => onChange(item.value) }),
                react_1.default.createElement(PillsMultipleSelect_styles_1.RadioLabel, { htmlFor: item.value, "$inlineTranslation": !!translationKey },
                    react_1.default.createElement(PillsMultipleSelect_styles_1.IconContainer, null, Icon && react_1.default.createElement(Icon, null)),
                    react_1.default.createElement(PillsMultipleSelect_styles_1.LabelSpan, { "$disabled": !!item.disabled, "$inlineTranslation": !!translationKey }, translationKey ? (react_1.default.createElement(forms_1.EditableTitle, { name: item.label, editHandler: (isCancelled, value) => translationEditHandler &&
                            value &&
                            translationEditHandler(isCancelled, value, item.labelTranslationKey), isEditable: !!translationKey })) : (item.label)))));
        }))));
};
exports.PillsMultipleSelect = PillsMultipleSelect;
//# sourceMappingURL=PillsMultipleSelect.js.map